export default class CookiePrompt {
    constructor(rootElement, httpClient) {
        this.rootElement = rootElement;
        this.httpClient = httpClient;

        this.acceptPreferencesButton = rootElement.querySelector('.cookie-ack-accept-preferences');
        this.showPreferencesButton = rootElement.querySelector('.cookie-ack-show-preferences');
        this.acceptAllButton = rootElement.querySelector('.cookie-ack-accept-all');
        this.closeDetailsButton = rootElement.querySelector('.ack-close-details');
        this.denyAllButton = rootElement.querySelector('.cookie-ack-deny-all');

        this.cookieTypeDetails = rootElement.querySelector('.cookie-type-details');
        this.ackButtons = rootElement.querySelector('.ack-buttons');
    }

    init() {
        this.showPreferencesButton.addEventListener('click', () => this._onShowPreferencesClick());
        this.acceptAllButton.addEventListener('click', () => this._onAcceptAllClick());
        this.denyAllButton.addEventListener('click', () => this._onDenyAllClick());
        this.closeDetailsButton.addEventListener('click', () => this._onCloseDetailsClick());
        this.acceptPreferencesButton.addEventListener('click', () => this._onAcceptPreferences());
    }

    _onShowPreferencesClick() {
        this.ackButtons.classList.remove('d-flex');
        this.ackButtons.classList.add('d-none');
        this.cookieTypeDetails.classList.remove('d-none');
        this.closeDetailsButton.classList.remove('d-none');
    }

    _onCloseDetailsClick() {
        this.ackButtons.classList.add('d-flex');
        this.ackButtons.classList.remove('d-none');
        this.cookieTypeDetails.classList.add('d-none');
        this.closeDetailsButton.classList.add('d-none');
    }

    _onAcceptAllClick() {
        const preferences = this._getPreferences();
        Object.keys(preferences).forEach((code) => {
            preferences[code] = true;
        });

        this._savePreferences(preferences);
    }

    _onDenyAllClick() {
        const preferences = this._getPreferences();
        Object.keys(preferences).forEach((code) => {
            preferences[code] = false;
        });

        this._savePreferences(preferences);
    }

    _onAcceptPreferences() {
        const preferences = this._getPreferences();
        this._savePreferences(preferences);
    }

    _getPreferences() {
        const checkboxes = this.cookieTypeDetails.querySelectorAll('input[data-cookie-type-code]');

        const preferences = {};
        [...checkboxes].forEach((checkbox) => {
            const cookieTypeCode = checkbox.getAttribute('data-cookie-type-code');
            preferences[cookieTypeCode] = checkbox.checked;
        });

        return preferences;
    }

    _savePreferences(preferences) {
        const saveCookiePreferencesUrl = this.rootElement.getAttribute('data-save-cookie-preferences-url');

        this.httpClient({
            type: 'POST',
            url: saveCookiePreferencesUrl,
            dataType: 'json',
            data: {
                cookie_preferences: preferences
            },
            success: () => {
                this._hideCookiePrompt();
            },
            error: (response) => {
                console.error('Failed to save cookie preferences', response);
            },
        });
    }

    _hideCookiePrompt() {
        const now = new Date();
        now.setMonth(now.getMonth() + 1);
        document.cookie = "cookies-usage-ack=1; expires=" + now.toUTCString() + "; path=/";

        this.rootElement.classList.add('d-none');
    }
}
